export default "/images/phone-input-flags.png?3f9d4c2eaac6057ce601cdedaf27cb10";